import { useWorkspace } from '@/hooks/useWorkspace';
import type { TreeItem } from '@/lib/tree/types';
import { listToTree } from '@/utils/format';
import { useMemo } from 'react';

const useSidebarChatbots = (type: 'sidebar' | 'breadcrumb' = 'breadcrumb') => {
  const { data, isLoading } = useWorkspace();

  const sidebarOptions = useMemo(() => {
    if (!data) return null;

    // Use displayOrder to sort chatbots

    const filteredChatbots =
      type === 'sidebar'
        ? data.entities.filter((chatbot) => chatbot.type === 'GROUP')
        : data.entities;

    if (!data.teamId)
      return {
        empty: filteredChatbots.length === 0,
        hasTeam: false,
        tree: listToTree(filteredChatbots),
      };

    return {
      empty: filteredChatbots.length === 0,
      hasTeam: !!data.teamId,
      teamId: data.teamId,
      tree: listToTree(filteredChatbots) as TreeItem[],
    };
  }, [data, type]);

  return { sidebarOptions, isLoading };
};

export default useSidebarChatbots;
